import { Component, computed, inject, OnInit } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs';
import { MyRewards } from '@ribera-web/rewards-feature';
import { PromotersWalletTransfer } from '@ribera-web/wallet-feature';
import { ShellDataService } from '@ribera-web/auth-data-acess';
import { MenuMobilePromoter } from '../menu-mobile-promoter/menu-mobile-promoter';
import { MenuMobilePartner } from '../menu-mobile-partner/menu-mobile-partner';

@Component({
  selector: 'lib-header-promoters',
  imports: [BreadcrumbModule, MyRewards, PromotersWalletTransfer, MenuMobilePromoter, MenuMobilePartner],
  templateUrl: './header-promoters.html',
  styleUrl: './header-promoters.scss',
})
export class HeaderPromoters implements OnInit {

  shellDataService = inject(ShellDataService);

  penFlag: string | null = null;

  items = [
    { icon: "shell/header/home.svg", label: "Inicio", url: "/home" },
    { label: "Inicio", url: "/home" },
  ];
  
  private router = inject(Router)
  private route = inject(ActivatedRoute);

  isPromotorPerfil = computed(() => this.shellDataService.isPromotorPerfil());

  itemss: MenuItem[] = [];

  home: MenuItem = { icon: 'home-svg', routerLink: '/' };
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isActive(item: any) {
    return this.router.url == item.url;
  }
  
  goToRibera() {
    window.open('https://dev-v2.cieneguillariberadelrio.com');
  }

  menuVisible = false;
  bookingsSubmenuOpen = false;

  viewRewardWallet = false;

   private readonly DEFAULT_TOKEN =
    'eyJhbGciOiJIUzM4NCJ9.eyJzdWIiOiJZQTQwNjYxMjY4Iiwicm9sZXMiOlt7ImF1dGhvcml0eSI6IjEifV0sImlkIjo3NTcsInN0YXRlIjoiQUNUSVZFIiwiaWF0IjoxNzYyMjkyOTU0LCJleHAiOjE3NjIyOTY1NTR9.LaBt-Ay5UQW1MBJhme0igZ9GKDLsMf-83eQN_enpsKCCig0QAOalftCRpwgrDqaB';

  ngOnInit(): void {
    this.itemss = this.buildBreadcrumb(this.route.root);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.itemss = this.buildBreadcrumb(this.route.root);
      });
  }

  toggleMenu() {
    this.menuVisible = !this.menuVisible;
    this.viewRewardWallet = false; 
  }

  toggleMenuRewards() {
    this.viewRewardWallet = !this.viewRewardWallet;
    this.menuVisible = false;
  }

  get isLoggedIn(): boolean {
    // Verifica si hay un token válido (no el token por defecto)
    const token = localStorage.getItem('accessToken');
    return !!token && token !== this.DEFAULT_TOKEN;
  }

  closeMenu() {
    this.menuVisible = false;
  }

  toggleBookingSubmenu(event: Event) {
    event.stopPropagation();
    this.bookingsSubmenuOpen = !this.bookingsSubmenuOpen;
  }

  goToDashboard() {
    this.shellDataService.redirectPerfilStorage();
  }

  goToPoints() {
    this.router.navigate(['/points']);
  }

  logoOut() {
    localStorage.removeItem('accessToken');
    this.router.navigate(['/auth/login']);
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }

  private buildBreadcrumb(route: ActivatedRoute, url = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const children: ActivatedRoute[] = route.children;

    for (const child of children) {
      // Construye la URL parcial de este child
      const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;

        // Label con mayúscula inicial y guiones reemplazados
        const rawLabel = child.snapshot.data['breadcrumb'] || routeURL.replace(/-/g,' ').replace(/\//g,' ');
        const label = rawLabel.charAt(0).toUpperCase() + rawLabel.slice(1);

        breadcrumbs.push({ label, routerLink: url });
      }

      // Recurse en los hijos del child
      this.buildBreadcrumb(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }
}
